import type { JurisdictionResponse } from "@/lib/types";
import SortButton from "./SortButton";

interface Props {
  sortColumn: string;
  sortDirection: "ascending" | "descending";
  changeSort: (column: string) => void;
  jurisdiction: JurisdictionResponse;
}

export default function DocumentsTableHeadersBridge(props: Props) {
  return (
    <thead>
      <tr>
        <th />
        <th style={{ minWidth: "125px" }}>
          <SortButton
            direction={
              props.sortColumn === "name" ? props.sortDirection : undefined
            }
            onClick={() => props.changeSort("name")}
          >
            Document Name
          </SortButton>
        </th>
        <th style={{ width: "93px" }}>
          <SortButton
            direction={
              props.sortColumn === "type" ? props.sortDirection : undefined
            }
            onClick={() => props.changeSort("type")}
          >
            Doc Type
          </SortButton>
        </th>
        <th style={{ width: "100px" }}>
          <SortButton
            direction={
              props.sortColumn === "uploadDate"
                ? props.sortDirection
                : undefined
            }
            onClick={() => props.changeSort("uploadDate")}
          >
            Upload Date
          </SortButton>
        </th>
        <th style={{ width: "135px" }}>
          <SortButton
            direction={
              props.sortColumn === "propoundingParty"
                ? props.sortDirection
                : undefined
            }
            onClick={() => props.changeSort("propoundingParty")}
          >
            Propounding Party
          </SortButton>
        </th>
        <th style={{ width: "135px" }}>
          <SortButton
            direction={
              props.sortColumn === "respondingParty"
                ? props.sortDirection
                : undefined
            }
            onClick={() => props.changeSort("respondingParty")}
          >
            Responding Party
          </SortButton>
        </th>
        {!!props.jurisdiction?.supportsDueDates && (
          <>
            <th style={{ width: "93px" }}>
              <SortButton
                direction={
                  props.sortColumn === "realDueDate"
                    ? props.sortDirection
                    : undefined
                }
                onClick={() => props.changeSort("realDueDate")}
              >
                Due Date
              </SortButton>
            </th>
            <th />
          </>
        )}
        <th style={{ width: "120px", minWidth: "120px" }}>
          <SortButton
            direction={
              props.sortColumn === "client" ? props.sortDirection : undefined
            }
            onClick={() => props.changeSort("client")}
          >
            Client
          </SortButton>
        </th>
        <th style={{ width: "275px" }}>Client Activity</th>
        <th style={{ width: "120px" }} />
        <th />
      </tr>
    </thead>
  );
}
